import { Tooltip, TooltipTrigger, TooltipContent } from '@wellesley/ui'

import OP from './OP.svg'

const OriginalPoster = () => (
  <span
    data-testid="original-poster"
    className="ml-xxxs flex min-h-[18px] items-center justify-center self-start rounded-[3px] text-base text-gray-700"
  >
    <Tooltip>
      <TooltipTrigger className="min-w-6">
        <img height={18} src={OP} alt="original poster" />
      </TooltipTrigger>
      <TooltipContent theme="dark" size="small" align="center">
        Original Poster
      </TooltipContent>
    </Tooltip>
  </span>
)

export default OriginalPoster
